import { USER } from "@/data/user";
import type { NavItem } from "@/types/nav";

export const SITE_INFO = {
  url: "https://binx.com",
  name: "BinX",
  title: "BinX",
  description: "A Really Cool Site",
  creator: "binx",
};

export const META_THEME_COLORS = {
  light: "#fafafa",
  dark: "#0a0a0a",
};

export const MAIN_NAV: NavItem[] = [
  {
    title: "Home",
    href: "/",
  },
  {
    title: "Components",
    href: "/components",
  },
  {
    title: "Blog",
    href: "/blog",
  },
];

export const SOURCE_CODE_GITHUB_URL = "https://github.com/user/binx.com";

export const UTM_PARAMS = {
  utm_source: "binx.com",
  utm_medium: "referral",
  utm_campaign: "home",
};

export const TWITTER_PROFILE = {
  name: "Binx",
  handle: "binx",
};

export const SITE_META = {
  name: "ChanhDai",
  fullName: "Chanh Dai",
  // ... existing code ...
};
